var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtitles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22 10h-3.5a3.5 3.5 0 0 0-3.5 3.5V22H4c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2h16c1.105 0 2 .895 2 2v6zM5.385 14C4.619 14 4 14.596 4 15.333v2c0 .737.62 1.334 1.385 1.334h6.23L13 20v-4.667c0-.737-.62-1.333-1.385-1.333h-6.23zm1.076 1.758c.387 0 .703.315.703.703a.704.704 0 0 1-.703.703.704.704 0 0 1-.703-.703c0-.388.315-.703.703-.703zm2.109 0c.387 0 .703.315.703.703a.704.704 0 0 1-.703.703.704.704 0 0 1-.703-.703c0-.388.315-.703.703-.703zm2.109 0c.387 0 .703.315.703.703a.704.704 0 0 1-.703.703.704.704 0 0 1-.703-.703c0-.388.315-.703.703-.703zm10.936-2.044h-.964c-.62 0-.689.215-.689.715v.928h1.447L21.339 17h-1.308v5h-2.204v-5H17v-1.714h.827v-1.072c0-1.428.55-2.214 2.135-2.214h1.653v1.714z",
    id: "subtitles-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#subtitles-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitles);
export default __webpack_public_path__ + "static/media/subtitles.199ce7fdb39cef5ccd307b19affb7669.svg";
export { ForwardRef as ReactComponent };